var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBussola(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-234.552 -211.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.681 220.753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.691,256.967a17.685,17.685,0,1,1,17.685-17.685A17.7,17.7,0,0,1,258.691,256.967Zm0-34.215a16.53,16.53,0,1,0,16.53,16.53A16.549,16.549,0,0,0,258.691,222.752Z",
    transform: "translate(-241.007 -221.597)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.895 9.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.227,244.295a.58.58,0,0,1-.412-.172l-6.117-6.21a.578.578,0,0,1,.178-.934L268.147,232a.578.578,0,0,1,.758.77l-5.153,11.192a.576.576,0,0,1-.425.328A.724.724,0,0,1,263.227,244.295Zm-5.118-6.6,4.943,5.019,4.164-9.045Z",
    transform: "translate(-251.379 -231.949)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.416,249.8a.578.578,0,0,1-.526-.82l5.153-11.192a.578.578,0,0,1,.937-.164l6.117,6.211a.579.579,0,0,1-.178.935l-11.27,4.981A.58.58,0,0,1,251.416,249.8Zm5.327-10.769-4.163,9.044,9.107-4.026Z",
    transform: "translate(-250.838 -232.472)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.155,
    height: 2.634,
    transform: "translate(17.106 0.582)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.155,
    height: 2.633,
    transform: "translate(17.106 32.158)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.633,
    height: 1.155,
    transform: "translate(32.156 17.109)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.634,
    height: 1.155,
    transform: "translate(0.579 17.109)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.691,256.967a17.685,17.685,0,1,1,17.685-17.685A17.7,17.7,0,0,1,258.691,256.967Zm0-34.215a16.53,16.53,0,1,0,16.53,16.53A16.549,16.549,0,0,0,258.691,222.752Z",
    transform: "translate(-0.326 -0.844)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.366,259.737a20.782,20.782,0,1,1,20.783-20.783A20.806,20.806,0,0,1,258.366,259.737Zm0-40.409a19.627,19.627,0,1,0,19.627,19.626A19.648,19.648,0,0,0,258.366,219.329Z",
    transform: "translate(0 -0.518)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.577 230.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.227,244.295a.58.58,0,0,1-.412-.172l-6.117-6.21a.578.578,0,0,1,.178-.934L268.147,232a.578.578,0,0,1,.758.77l-5.153,11.192a.576.576,0,0,1-.425.328A.724.724,0,0,1,263.227,244.295Zm-5.118-6.6,4.943,5.019,4.164-9.045Z",
    transform: "translate(-251.379 -231.949)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.416,249.8a.578.578,0,0,1-.526-.82l5.153-11.192a.578.578,0,0,1,.937-.164l6.117,6.211a.579.579,0,0,1-.178.935l-11.27,4.981A.58.58,0,0,1,251.416,249.8Zm5.327-10.769-4.163,9.044,9.107-4.026Z",
    transform: "translate(-250.838 -232.472)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.155,
    height: 2.634,
    transform: "translate(257.788 215.599)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.155,
    height: 2.634,
    transform: "translate(257.788 221.335)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.155,
    height: 2.633,
    transform: "translate(257.788 252.912)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.837,216.177h-7.75a1.723,1.723,0,1,1,0-3.446h7.75a1.723,1.723,0,0,1,0,3.446Zm-7.749-2.29a.567.567,0,1,0,0,1.135h7.75a.567.567,0,1,0,0-1.135Z",
    transform: "translate(-1.596)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussola);
export default __webpack_public_path__ + "static/media/bussola.a8099639748dee9ce1ac9f73c1fca917.svg";
export { ForwardRef as ReactComponent };